import { DoubleSide, MeshBasicMaterial, Object3D } from "three";
import { Font } from "opentype.js";

import { makeText } from "../../../../lib/misc/text";

export class TrackLabel extends Object3D {
  constructor(text: string, font: Font, color = Math.random() * 0xffffff) {
    super();

    const mesh = makeText(
      text,
      new MeshBasicMaterial({
        color: color,
        transparent: true,
        side: DoubleSide,
      }),
      font
    );

    if (mesh) {
      this.add(mesh);
      mesh.rotateX(Math.PI);
    }
  }
}
